import TimelineNode from 'components/dossiers/dossierFollowUp/TimelineNode';
import React from 'react'
import { Button, Grid, Header, Item, Menu, Segment } from "semantic-ui-react";
import EditModal from "../../forms/EditModal";
import ActionsMenu from "./ActionsMenu";
import AttachmentPreview, { getAttachmentType } from "./AttachmentPreview";
import DossierAttachmentForm from "./DossierAttachmentForm";

export default class AttachmentNode extends React.Component {
  render() {
    const { isSelected, time, nodeStyle } = this.props
    let dossierItemId = this.props.dossierItem.id
    let attachmentUrl = this.props.dossierItem.attachmentExpiringUrl
    let attachmentType = getAttachmentType(attachmentUrl)
    let hrefString = Routes.download_api_dossier_item_path({ id: dossierItemId, _options: true })
    return (
      <TimelineNode icon={'attach'} type={'note'} {...this.props}>
        <Item as={Segment} raised={isSelected} clearing contentEditable={false} style={nodeStyle}>
          <Item.Content>
            <Grid divided>
              <Grid.Row>
                <Grid.Column width={9}>
                  <Header href={hrefString} target="_blank" rel="noopener noreferrer">
                    {this.props.dossierItem.attachmentTitle}
                  </Header>
                  <Item.Description>{I18n.l("date.formats.short_human_readable", time)}</Item.Description>
                </Grid.Column>
                <Grid.Column width={5} floated='right' textAlign='right' className='dont-print'>
                  <Menu compact borderless secondary stackable>
                    <Menu.Item>
                      <EditModal entityName="dossierItem" EntityForm={DossierAttachmentForm}
                                 entityId={this.props.dossierItem.id} trigger={(props) => {
                        return (<Button onClick={props.onClick} icon='pencil'/>)
                      }}
                      />
                    </Menu.Item>
                    <ActionsMenu attachmentId={dossierItemId} attachmentType={attachmentType}/>
                  </Menu>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Item.Content>
          <AttachmentPreview
            href={hrefString}
            url={attachmentUrl}
            title={this.props.dossierItem.attachmentTitle}
            attachmentType={attachmentType}
            showInlineImages={this.props.showInlineImages}
            showInlinePdfs={this.props.showInlinePdfs}
          />
        </Item>
      </TimelineNode>)
  }
}
